import { useParams } from "react-router-dom";

const getInitials = (name) => {
  if (!name) return "NA";
  const words = name.trim().split(" ");
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }
  return (words[0][0] + words[1][0]).toUpperCase();
};

export default function VendorLogo({ slug }) {

  const vendorName = slug;
  const initials = getInitials(vendorName);

  // Use environment variable for base URL
  const BASE_URL = process.env.REACT_APP_BASE_URL_DEV;

  // Construct vendor logo URL
  const vendorLogo = `${BASE_URL}/forms/slug/${slug}/logo`;

  return (
    <div className="vendor-logo-wrap">
      <img
        src={vendorLogo}
        alt={vendorName}
        className="vendor-logo"
        onError={(e) => {
          e.currentTarget.style.display = "none";
          e.currentTarget.nextSibling.style.display = "flex";
        }}
      />

      {/* Avatar fallback */}
      <div
        className="vendor-avatar"
        style={{ display: "none" }}
      >
        {initials}
      </div>
    </div>
  );
}
